$('document').ready(function() {
  var priceContainer = 'ph-productpricecontainer',
      addShoppingContainer = 'ph-addtoshoppinglist-container';

  $('#ph-addnewlist').click(function() {
    $(this).parents('.' + priceContainer).find('.' + addShoppingContainer).toggle();
    $(this).toggleClass('shoppingListClicked');
  });

  $('.closeaddtoshoppingList').click(function() {
    $(this).parents('.' + addShoppingContainer).toggle();
  });

  function creatNewListPrdList(alreadyExists, obj) {
    if (alreadyExists === 0) {
      var prependList = obj.orderName;

      if (prependList.length > 15) {
        prependList = prependList.substring(0, 15) + '..';
      }

      $('.addtoshoppinglist').prepend('<li><a href=\'javascript:void();\' class=\'shoppingListName-prdlist\' id=\'shoppingList-prdlist' + length +
      '\' data-listName=\'' + obj.orderName + '\'>' + prependList +
      '</a> <span class=\'addtoshoppinglist-prdlist-count\'>(' + obj.orderProductCount + ')</span></li>');
    }

    setTimeout(function() {
      $('#white_content')
        .fadeOut();
    }, 5000);
  }

  $('.createNewListButton-prdlist').click(function() {
    var listname = $(this).parent('.ph-createnewlistset').find('.createnewlist-txt').val(),
        productCode = $(this).parents('.' + priceContainer).find('.addToShoppingListProductCode').val();

    /* eslint-disable  no-useless-escape */
    listname = listname.replace(/[^a-zA-Z0-9 \-\_]/g, '');
    /* eslint-enable  no-useless-escape */
    listname = listname.replace(/\s{2,}/g, ' ');

    if (listname !== null && listname.trim() !== null && listname.trim() !== '') {
      listname = listname.trim();
      $.ajax({
        url: ACC.config.contextPath + '/shoppingList/addProductToList',
        data: {
          orderName: listname,
          productCode: productCode
        },
        type: 'POST',
        datatype: 'json',
        success: function(result) {
          var alreadyExists = 0,
              length = $('.addtoshoppinglist li').length,
              obj = $.parseJSON(JSON.stringify(result));

          for (var i = 0; i < length; i = i + 1) {
            var listId = '#shoppingList-prdlist' + i,
                list = $(listId).attr('data-listName');

            if (typeof list !== 'undefined' && listname.toLowerCase() === list.toLowerCase()) {
              alreadyExists = 1;
              $('#shoppingListProductcount-prdlist' + i).text('(' + obj.orderProductCount + ')');

              break;
            }
          }

          $('.' + priceContainer).each(function() {
            $('.' + addShoppingContainer).hide();
          });
          creatNewListPrdList(alreadyExists, obj);
          $('.createnewlist-txt').val('');
        }
      });
    }

    $('.createNewListButton-prdlist').click(function() {
      $('.addtoshoppinglist li:even').removeClass('sam').removeClass('sams').addClass('sam');
      $('.addtoshoppinglist li:odd').removeClass('sam').removeClass('sams').addClass('sams');
    });
  });


  $('.shoppingListName-prdlist').click(function() {
    var listname = $(this).attr('data-listName');
    var listNumber = $(this).attr('data-listNumber');
    var productCode = $(this).parents('.' + priceContainer).find('.addToShoppingListProductCode').val();

    $.ajax({
      url: ACC.config.contextPath + '/shoppingList/addProductToList',
      data: {
        orderName: listname,
        productCode: productCode
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        $('.' + priceContainer).each(function() {
          $('.' + addShoppingContainer).hide();
        });

        var obj = $.parseJSON(JSON.stringify(result));
        var spanId = 'shoppingListProductcount-prdlist' + listNumber;

        $('.' + spanId).html('(' + obj.orderProductCount + ')');
      }
    });
  });
});
